"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetLineWin = void 0;
/**
 *
 * Basic BetLine win presentation. Plays symbol "win" state animations one bet line win after another.
 * It resets the symbols to normal on abort.
 *
 * For use in "idleLoop" gameRound state, usually when there is no ZeroBet.
 *
 * Created by Jonas Wålekvist on 2019-08-12.
 */
const gsap_1 = require("gsap");
const GameConfig_1 = require("../../../../core/gameconfig/GameConfig");
const ParsedGameData_1 = require("../../../../core/server/data/ParsedGameData");
const Reels_1 = require("../../../../core/reel/reelarea/Reels");
const EventHandler_1 = require("../../../../core/event/EventHandler");
const GameEvent_1 = require("../../../../core/event/GameEvent");
const BetLineEvent_1 = require("../../../../core/betline/event/BetLineEvent");
class BetLineWin {
    constructor(stagger) {
        this.stagger = stagger;
    }
    abort(isActive, data) {
        const tl = new gsap_1.TimelineLite();
        tl.add(() => BetLineWin.hideAllBetLines());
        for (let reelId = 0; reelId < 5; reelId++) {
            for (let symbolId = 0; symbolId < 3; symbolId++) {
                tl.add(this.getSymbolAnimation(reelId, symbolId, GameConfig_1.GameConfig.instance.SYMBOL_STATES.normal), 0);
            }
        }
        return tl;
    }
    getAnimation(data) {
        if (!(data instanceof ParsedGameData_1.ParsedGameData) || data.betWins == undefined || data.betWins.length <= 0) {
            return null;
        }
        return this.getWinAnimations(data);
    }
    getWinAnimations(data) {
        const tl = new gsap_1.TimelineLite();
        for (let i = 0; i < data.betWins.length; i++) {
            tl.add([
                () => BetLineWin.showBetLine(data.betWins[i].betLineIndex),
                this.getLineAnimation(data.betWins[i])
            ]);
            tl.add(() => BetLineWin.hideBetLine(data.betWins[i].betLineIndex));
        }
        return tl;
    }
    getLineAnimation(betLineWinData) {
        const tl = new gsap_1.TimelineLite();
        for (let reelId = 0; reelId < betLineWinData.nrOfSymbols; reelId++) {
            tl.add(this.getSymbolAnimation(reelId, betLineWinData.betLine[reelId], GameConfig_1.GameConfig.instance.SYMBOL_STATES.win), 0);
        }
        return tl;
    }
    getSymbolAnimation(reelId, symbolId, state) {
        const tl = new gsap_1.TimelineLite();
        const symbol = Reels_1.Reels.getSymbol(reelId, symbolId);
        if (symbol) {
            const symbolAnimation = symbol.changeState({
                state: state,
                setStack: true,
                fadeInDuration: 0.0
            });
            tl.add([
                () => BetLineWin.sortSymbolDepthToTop(symbol),
                symbolAnimation
            ]);
        }
        else {
            debugger;
            throw new Error(`Error: BetLineWin: Cannot find symbol at reel ${reelId} symbol ${symbolId}`);
        }
        return tl;
    }
    static sortSymbolDepthToTop(symbol) {
        if (symbol && symbol.parent) {
            symbol.parent.addChild(symbol);
        }
    }
    static showBetLine(betLineIndex) {
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(BetLineEvent_1.BetLineEvent.SHOW_WIN_BET_LINE, betLineIndex + 1));
    }
    static hideBetLine(betLineIndex) {
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(BetLineEvent_1.BetLineEvent.HIDE_WIN_BET_LINE, betLineIndex + 1));
    }
    static hideAllBetLines() {
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(BetLineEvent_1.BetLineEvent.HIDE_ALL_BET_LINES));
    }
}
exports.BetLineWin = BetLineWin;
//# sourceMappingURL=BetLineWin.js.map